"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformType = exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["Desktop"] = "DESKTOP";
    DeviceType["Mobile"] = "MOBILE";
    DeviceType["Tablet"] = "TABLET";
    DeviceType["MShop"] = "MSHOP";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));
var PlatformType;
(function (PlatformType) {
    PlatformType["Ios"] = "IOS";
    PlatformType["Android"] = "ANDROID";
    PlatformType["Desktop"] = "DESKTOP";
})(PlatformType = exports.PlatformType || (exports.PlatformType = {}));
